import {
  getSortOrderFromHeaderClick,
  downloadFile,
  routeNavigationUrl,
} from "helpers/util-common";
import { orderTypeAsc, PaginateOrder } from "../../members.model";

let self = null;
let letterBallot_param = null;
let memberAccountNumber_param = null;
let memberId_param = null;
let headerInfo = null;
let voteStatus_param = null;
const Defaulr_Sotring = "ItemNumber";

export const setInstance = (instance) => {
  self = instance;
};

export const setInitialData = () => {
  const { initialValues, ballotNumber, ballotVoteStatus } = self.props;
  const { MemberId, AccountNumber } = initialValues;
  letterBallot_param = ballotNumber;
  memberAccountNumber_param = AccountNumber;
  memberId_param = MemberId;
  voteStatus_param = ballotVoteStatus;
  headerInfo.map((item) => {
    item["orderByIcon"] = PaginateOrder['sortNEnabled'];
    item["orderBy"] = PaginateOrder['sortNEnabled'];
  });
  headerInfo[0]["orderByIcon"] = PaginateOrder['sortEnabled'];
  headerInfo[0]["orderBy"] = PaginateOrder['sortEnabled'];
  if (parseInt(ballotVoteStatus) === 2) {
    const dtoArguments = [
      ballotNumber,
      self.state.sortBy,
      self.state.sortOrder,
      self.state.index,
      self.state.pageSize,
    ];
    self.props.getBallotItemsByLetterBallot(...dtoArguments, (response) => {
      const responseData = response.map((elm) => ({
        BallotItemNumber: elm.ItemNumber,
      }));
      self.setState({
        VoteDetailsList: {
          BallotNumber: ballotNumber,
          VoteStatus: ballotVoteStatus,
          VoteDate: "",
          BallotVoteItems: responseData,
        },
        TotalRecords: response[0].TotalRecords,
      });
    });
  } else {
    let reqData = {
      letterBallot: letterBallot_param,
      memberId: memberId_param,
      sortBy: self.state.sortBy,
      sortOrder: self.state.sortOrder,
      offset: self.state.pageNumber,
      limit: self.state.pageSize,
      memberAccountNumber: memberAccountNumber_param,
    };
    self.props.getVoteDetailsList(reqData, (response) => {
      self.setState({
        VoteDetailsList: response,
        TotalRecords: response ? response.TotalRows : "",
      });
    });
  }
};

export const getLetterBallot = () => letterBallot_param;

export const getMemberAccountNumber = () => memberAccountNumber_param;

export const getMemberId = () => memberId_param;

export const getVoteStatus = () => voteStatus_param;

export const sortByHandler = (event, sortKey) => {
  let orderType = getSortOrderFromHeaderClick(event);
  const sortOrder = orderType === orderTypeAsc ? "Asc" : "Desc";
  if (getVoteStatus() === 2 && sortKey === Defaulr_Sotring) {
    const dtoArguments = [
      letterBallot_param,
      sortKey,
      sortOrder,
      self.state.pageNumber,
      self.state.pageSize,
    ];
    self.props.getBallotItemsByLetterBallot(...dtoArguments, (response) => {
      const responseData = response.map((elm) => ({
        BallotItemNumber: elm.ItemNumber,
      }));
      self.setState({
        VoteDetailsList: {
          BallotNumber: letterBallot_param,
          VoteStatus: getVoteStatus(),
          VoteDate: "",
          BallotVoteItems: responseData,
        },
        TotalRecords: response[0].TotalRecords,
        sortBy: sortKey,
      });
    });
  } else if (getVoteStatus() === 2 && sortKey !== Defaulr_Sotring) {
    self.setState({ sortBy: Defaulr_Sotring, pageNumber: 1 }, () => {
      setInitialData();
    });
  } else {
    let reqData = {
      letterBallot: letterBallot_param,
      memberId: memberId_param,
      sortBy: sortKey,
      sortOrder: sortOrder,
      offset: self.state.pageNumber,
      limit: self.state.pageSize,
    };
    self.props.getVoteDetailsList(reqData, (response) => {
      self.setState({
        VoteDetailsList: response,
        TotalRecords: response ? response.TotalRows : "",
        sortBy: sortKey,
      });
    });
  }
};

export const resetBallotHeaderInfo = (item) => {
  headerInfo = item;
  const arrayData = item.findIndex((element) => element.orderByIcon === 1);
  if (arrayData > 0) {
    item[arrayData]["orderByIcon"] = PaginateOrder['sortNEnabled'];
    item[0]["orderByIcon"] = PaginateOrder['sortEnabled'];
  }
};

export const onPageChangeHandler = (event, data) => {
  if (getVoteStatus() === 2) {
    self.setState(
      { pageNumber: data.activePage, sortBy: Defaulr_Sotring },
      () => {
        const dtoArguments = [
          letterBallot_param,
          self.state.sortBy,
          self.state.sortOrder,
          self.state.pageNumber,
          self.state.pageSize,
        ];
        self.props.getBallotItemsByLetterBallot(...dtoArguments, (response) => {
          const responseData = response.map((elm) => ({
            BallotItemNumber: elm.ItemNumber,
          }));
          self.setState({
            VoteDetailsList: {
              BallotNumber: letterBallot_param,
              VoteStatus: getVoteStatus(),
              VoteDate: "",
              BallotVoteItems: responseData,
            },
            TotalRecords: response[0].TotalRecords,
            pageNumber: data.activePage,
          });
        });
      }
    );
  } else {
    self.setState({ pageNumber: data.activePage }, () => {
      let reqData = {
        letterBallot: letterBallot_param,
        memberId: memberId_param,
        sortBy: self.state.sortBy,
        sortOrder: self.state.sortOrder,
        offset: self.state.pageNumber,
        limit: self.state.pageSize,
      };
      self.props.getVoteDetailsList(reqData, (response) => {
        self.setState({
          VoteDetailsList: response,
          TotalRecords: response ? response.TotalRows : "",
          pageNumber: data.activePage,
        });
      });
    });
  }
};

export const onChangeNumberOfItemsPerPage = (e, value) => {
  headerInfo.map((item) => {
    item["orderByIcon"] = PaginateOrder['sortNEnabled'];
    item["orderBy"] = PaginateOrder['sortNEnabled'];
  });
  headerInfo[0]["orderByIcon"] = PaginateOrder['sortEnabled'];
  headerInfo[0]["orderBy"] = PaginateOrder['sortEnabled'];
  if (getVoteStatus() === 2) {
    self.setState(
      { pageSize: value, pageNumber: 1, sortBy: Defaulr_Sotring },
      () => {
        const dtoArguments = [
          letterBallot_param,
          self.state.sortBy,
          self.state.sortOrder,
          self.state.index,
          self.state.pageSize,
        ];
        self.props.getBallotItemsByLetterBallot(...dtoArguments, (response) => {
          const responseData = response.map((elm) => ({
            BallotItemNumber: elm.ItemNumber,
          }));
          self.setState({
            VoteDetailsList: {
              BallotNumber: letterBallot_param,
              VoteStatus: getVoteStatus(),
              VoteDate: "",
              BallotVoteItems: responseData,
              TotalRecords: response[0].TotalRecords,
            },
            isNotSubmitted: true,
          });
        });
      }
    );
  } else {
    self.setState({ pageSize: value, pageNumber: 1 }, () => {
      let reqData = {
        letterBallot: letterBallot_param,
        memberId: memberId_param,
        sortBy: self.state.sortBy,
        sortOrder: self.state.sortOrder,
        offset: self.state.index,
        limit: self.state.pageSize,
      };
      self.props.getVoteDetailsList(reqData, (response) => {
        self.setState({
          VoteDetailsList: response,
          TotalRecords: response ? response.TotalRows : "",
          pageSize: value,
        });
      });
    });
  }
};

export const openModelComment = (index, item) => {
  self.setState({ CommentList: item, isOpenModelComment: true });
};

export const closeModelComment = () => {
  self.setState({ isOpenModelComment: false, CommentList: [] });
};

export const handleBallotFileClick = (event, docPath, isDMS) => {
  event.preventDefault();
  if (docPath) {
    self.props.downloadDocument(docPath, isDMS);
  }
};
